import PartsSpectrum from './partsSpectrum';
export default PartsSpectrum;
